<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar
            color="blue"
            dark
            dense
            flat
          >
            <v-toolbar-title class="white--text">
              排出事業者への再申請
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <div class="overline">
                  排出事業者
                </div>
                <h4>
                  {{ manifest.name }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <div class="overline">
                  メールアドレス１
                </div>
                <h4>
                  {{ manifest.email_1 }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="5">
                <div class="overline">
                  担当名１
                </div>
                <h4>
                  {{ manifest.staff_1 }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <div class="overline">
                  メールアドレス２
                </div>
                <h4>
                  {{ manifest.email_2 }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="5">
                <div class="overline">
                  担当名２
                </div>
                <h4>
                  {{ manifest.staff_2 }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <h4>
                  送信するメールアドレスを確認し、修正する場合は排出事業者マスタから行ってください。
                </h4>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              送信
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SendMailApprovalDialog',
  components: {},
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      manifest: null,
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      // this.manifest = null
      this.$nextTick(() => this.$refs.observer.reset())
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementSendMailApproval', {
      fetchManifest: 'edit',
      updateManifest: 'update',
    }),
    setVariable () {
      this.fetchManifest({ id: this.manifestId }).then((content) => {
        this.manifest = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validateWithInfo().then(({ isValid, errors }) => {
        if(isValid) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      this.updateManifest({ id: this.manifestId }).then(() => {
        this.$emit('registerCallback')
      })
    }
  }
}
</script>
